import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import MaskedInput from 'react-text-mask';

const InputMaksed = props => {
    const {
        label: { labelText, labelClasses, wrapperClasses, isRequired, ariaLabel },
        input: {
            id,
            name,
            inputClasses,
            placeholder,
            type,
            value,
            readOnly = false,
            maxLength,
            disabled,
            isInputRequired,
            mask,
        },
        actions: { handleFieldChange, handleFieldBlur, handleFieldFocus },
        labelIcon = {},
    } = props;

    const handleValueChange = e => {
        handleFieldChange(e.target.value);
    };

    const handleValueBlur = e => {
        handleFieldBlur && handleFieldBlur(e.target.value);
    };

    const handleValueFocus = e => {
        handleFieldFocus && handleFieldFocus(e.target.value);
    };

    return (
        <Fragment>
            <div className={`gi-input ${wrapperClasses && wrapperClasses.join(' ')}`}>
                <label
                    htmlFor={name}
                    className={`gi-input__label ${labelClasses && labelClasses.join(' ')} required-${isRequired}`}
                    aria-label={ariaLabel}
                    data-testid = {`${id}_input_label`}
                >
                    <FormattedMessage id={labelText} />
                    {labelIcon.icon ? labelIcon.icon : null}
                </label>
                <MaskedInput
                    id={id}
                    dataautomationid={id}
                    data-testid={id}
                    className={`gi-input__input ${inputClasses && inputClasses.join(' ')}`}
                    mask={mask}
                    disabled={disabled}
                    name={name}
                    type={type}
                    value={value || ''}
                    readOnly={readOnly}
                    aria-required={isInputRequired}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    onChange={handleValueChange}
                    onBlur={handleValueBlur}
                    onFocus={handleValueFocus}
                />
            </div>
        </Fragment>
    );
};

export default InputMaksed;
